export const ROUTE_NAMES = {
  HOME: "home",
  BLOG_LIST: "blogs",
  BLOG_DETAIL: "blog-detail",
  QI_MEN: "qi-men",
  I_CZIN: "iczin",
  DAY_RUNE_PREDICTION: "day-rune-prediction",
  TAROT: "tarot",
  TAROT_DAILY: "tarot-daily",
  TAROT_SITUATION: "tarot-situation",
  AZM: "azm",
  ACTIVATIONS: "activations",
  ACTIVATION_FORM: "activation-form",
  BAZI: "bazi",
  ROOM_MAPPING: "room-mapping",
  CHINESE_CALENDAR: "chinese-calendar",
  CHINESE_CALENDAR_DAY: "chinese-calendar-day",
  USER: "user",
  VERIFY_EMAIL: "verify-email",
  RESET_PASSWORD: "reset-password",
  DESTINY_MATRIX: "destiny-matrix",
  PERSONAL_DATE_SELECTION: "personal-date-selection",
} as const;
